import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  stepperUploadingTitle: {
    id: 'course-authoring.import.stepper.title.uploading',
    defaultMessage: 'Uploading',
  },
  stepperUnpackingTitle: {
    id: 'course-authoring.import.stepper.title.unpacking',
    defaultMessage: 'Unpacking',
  },
  stepperVerifyingTitle: {
    id: 'course-authoring.import.stepper.title.verifying',
    defaultMessage: 'Verifying',
  },
  stepperUpdatingTitle: {
    id: 'course-authoring.import.stepper.title.updating',
    defaultMessage: 'Updating сourse',
  },
  stepperSuccessTitle: {
    id: 'course-authoring.import.stepper.title.success',
    defaultMessage: 'Success',
  },
  stepperUploadingDescription: {
    id: 'course-authoring.import.stepper.description.uploading',
    defaultMessage: 'Transferring your file to our servers',
  },
  stepperUnpackingDescription: {
    id: 'course-authoring.import.stepper.description.unpacking',
    defaultMessage: 'Expanding and preparing folder/file structure (You can now leave this page safely, but avoid making drastic changes to content until this import is complete)',
  },
  stepperVerifyingDescription: {
    id: 'course-authoring.import.stepper.description.verifying',
    defaultMessage: 'Reviewing semantics, syntax, and required data',
  },
  stepperUpdatingDescription: {
    id: 'course-authoring.import.stepper.description.updating',
    defaultMessage: 'Integrating your imported content into this course. This process might take longer with larger courses.',
  },
  stepperSuccessDescription: {
    id: 'course-authoring.import.stepper.description.success',
    defaultMessage: 'Your imported content has now been integrated into this course',
  },
  viewOutlineButton: {
    id: 'course-authoring.import.stepper.button.outline',
    defaultMessage: 'View updated outline',
  },
  defaultErrorMessage: {
    id: 'course-authoring.import.stepper.error.default',
    defaultMessage: 'Error importing course',
  },
  stepperHeaderTitle: {
    id: 'course-authoring.import.stepper.header.title',
    defaultMessage: 'Course import status',
  },
  scormPreparationHeader: {
    id: 'course-authoring.import.stepper.scorm-preparation.header',
    defaultMessage: 'SCORM preparation',
  },
  scormPreparationLoading: {
    id: 'course-authoring.import.stepper.scorm-preparation.loading',
    defaultMessage: 'Checking SCORM preparation status.',
  },
  scormPreparationQueued: {
    id: 'course-authoring.import.stepper.scorm-preparation.queued',
    defaultMessage: 'SCORM content preparation is queued.',
  },
  scormPreparationRunning: {
    id: 'course-authoring.import.stepper.scorm-preparation.running',
    defaultMessage: 'Preparing SCORM content.',
  },
  scormPreparationCompleted: {
    id: 'course-authoring.import.stepper.scorm-preparation.completed',
    defaultMessage: 'SCORM content preparation is complete.',
  },
  scormPreparationCompletedWithWarnings: {
    id: 'course-authoring.import.stepper.scorm-preparation.completed-with-warnings',
    defaultMessage: 'SCORM preparation is complete, but some modules need attention.',
  },
  scormPreparationNotApplicable: {
    id: 'course-authoring.import.stepper.scorm-preparation.not-applicable',
    defaultMessage: 'No SCORM content needs preparation.',
  },
  scormPreparationFailed: {
    id: 'course-authoring.import.stepper.scorm-preparation.failed',
    defaultMessage: 'SCORM content preparation could not be completed.',
  },
  scormPreparationUnavailable: {
    id: 'course-authoring.import.stepper.scorm-preparation.unavailable',
    defaultMessage: 'SCORM preparation status is temporarily unavailable.',
  },
  scormPreparationStart: {
    id: 'course-authoring.import.stepper.scorm-preparation.start',
    defaultMessage: 'Prepare SCORM content',
  },
  scormPreparationRetry: {
    id: 'course-authoring.import.stepper.scorm-preparation.retry',
    defaultMessage: 'Retry preparation',
  },
  scormPreparationProgress: {
    id: 'course-authoring.import.stepper.scorm-preparation.progress',
    defaultMessage: 'Preparation progress: {progress}%',
  },
  scormPreparationWarnings: {
    id: 'course-authoring.import.stepper.scorm-preparation.warnings',
    defaultMessage: 'Some SCORM modules need attention:',
  },
  scormPreparationEditModule: {
    id: 'course-authoring.import.stepper.scorm-preparation.edit-module',
    defaultMessage: 'Edit and upload a replacement package.',
  },
});

export default messages;
